import { useState } from 'react';

import { MediaContextPlaybackStatus } from '#cutils/context/MediaContext';
import type { ArticleData } from '#shared/types/article';

import { ArticleModuleHero } from './Modules/ArticleModuleHero';
import { ArticleModuleTeaser } from './Modules/ArticleModuleTeaser';

type Props = {
	article: ArticleData;
	bodyClassName?: string;
};

export function ArticleHeader({ article, bodyClassName: bodyClassName = '' }: Props) {
	const [heroMediaPlaybackState, setHeroMediaPlaybackState] = useState(MediaContextPlaybackStatus.STOPPED);

	return (
		<header>
			<ArticleModuleHero
				article={article}
				onPlayStatusChange={(e) => {
					setHeroMediaPlaybackState(e);
				}}
			/>

			<ArticleModuleTeaser className={bodyClassName} article={article} heroMediaPlaybackState={heroMediaPlaybackState} />
		</header>
	);
}
